/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { HiDocumentAdd } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../utility/Constant";

const ContactCreate = () => {
  const { contactApi } = apiPath;
  const { contactList } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "input",
      label: "country",
      type: "Text",
      name: "country",
      required: true,
    },
    {
      elementType: "textField",
      label: "address",
      type: "Text",
      name: "address",
      required: true,
    },
  ];

  const update = async (data) => {
    data.slug = "ourOffices";
    const res = await updateData(contactApi, data, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + contactList;
      }, 600);

    }
  };

  return (
    <div>
      <h1 className="font-oswald font-bold text-2xl mt-2  uppercase md:pl-8">
        <HiDocumentAdd className="inline w-7 h-7 mb-1" /> Add new Office
      </h1>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ContactCreate;
